import { useMemo } from 'react';

/**
 * Memoized iOS detection hook
 * Prevents per-render UA string parsing
 */
export function useIsIOS(): boolean {
  return useMemo(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    const ua = navigator.userAgent || navigator.vendor || '';
    return /iPad|iPhone|iPod/.test(ua) && !(window as unknown as { MSStream?: unknown }).MSStream;
  }, []);
}

